import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FiX } from 'react-icons/fi';

import ContractorAuthenticationModal from '../../../components/family-plaza/ContractorAuthenticationModal';
import PortraitPhotoRegistrationModal from '../../../components/family-plaza/PortraitPhotoRegistrationModal';
import { checkModalAuthenticationStatus } from '../../../utils/authUtils';
import CyberMemorialService from '../../../services/FamilyPlaza/CyberMemorialService';
import DeceasedPersonProfile from '../../../components/family-plaza/DeceasedPersonProfile';
import FamilyPlazaSubHeading from '../../../components/family-plaza/FamilyPlazaSubHeading';
import FamilyPlazaTopSection from '../../../components/family-plaza/FamilyPlazaTopSection';


const MemorialAlbumWritingPC = () => {
  const navigate = useNavigate();
  const handleNavigation = (route) => { navigate(route); };
  
  const [title, setTitle] = useState('');
  const [photoDescription, setPhotoDescription] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState('/images/default4.png');
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [profilePhotoUrl, setProfilePhotoUrl] = useState('/donate/layer-1910.png');
  

  
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreviewImage(e.target.result);
        alert('업로드가 완료되었습니다.');
      };
      reader.readAsDataURL(file);
    }
  };

  const removeImage = () => {
    setSelectedFile(null);
    setPreviewImage('/images/default4.png');
  };

  const handleCancel = () => {
    // Navigate back to the album board list page
    navigate('/memorial-album-board-list');
  };

  const handleSubmit = async () => {
    // Validate required fields first
    if (!title.trim()) {
      alert('제목을 입력해주세요.');
      return;
    }
    
    // Check if a photo is attached (more flexible check)
    if (previewImage === '/images/default4.png' || !previewImage) {
      alert('사진을 첨부해주세요.');
      return;
    }
    
    // Check authentication status
    if (!checkModalAuthenticationStatus()) {
      setShowAuthModal(true);
      return;
    }
    
    // If authenticated and photo is attached, proceed with form submission
    const success = await saveAlbumData();
    // Always navigate to album list page, regardless of success
    navigate('/memorial-album-board-list');
  };

  const saveAlbumData = async () => {
    // Get selected person data for proper goinId and cherishId
    const selectedPersonData = localStorage.getItem('selectedPersonData'); 
       const getCherishId = localStorage.getItem('cherishId');

    let goinId = 0;
    let cherishId = 0;
    
    if (selectedPersonData) {
      try {
        const personData = JSON.parse(selectedPersonData);
        const parsedCherishId = JSON.parse(getCherishId);

        goinId = parseInt(personData.goinId);
        cherishId = parseInt(parsedCherishId);
      } catch (error) {
        goinId = 0;
        cherishId = 0;
      }
    }
      
    // Prepare data for API
    const apiData = {
      cherishId: cherishId,
      goinId: goinId,
      albumTitle: title.trim(),
      base64Image: previewImage !== '/images/default4.png' ? previewImage : '/gallery pc list/p-5070484.png'
    };
    
    try {
      // Create album via API
      const response = await CyberMemorialService.createMemorialAlbumEntry(apiData);
      
      if (response) {
        // Show success message
        alert('앨범이 성공적으로 등록되었습니다.');
        return true;
      } else {
        alert('앨범 등록에 실패했습니다.');
        return false;
      }
      
    } catch (error) {
      console.log('API error:', error);
      
      // Show user-friendly error message
      if (error.response) {
        // Server responded with error status
        alert(`서버 오류가 발생했습니다. (${error.response.status})`);
      } else if (error.request) {
        // Network error
        alert('네트워크 연결을 확인해주세요.');
      } else {
        // Other error
        alert('앨범 등록 중 오류가 발생했습니다.');
      }
      
      return false;
    }
  };

  const handlePhotoUpload = () => {
    // Trigger file input click
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.onchange = handleFileChange;
    fileInput.click();
  };

  const handleRemoveImage = () => {
    removeImage();
  };

  // Photo icon click handler
  const handlePhotoIconClick = () => {
    const isAuthenticated = checkModalAuthenticationStatus();
    
    if (isAuthenticated) {
      // If already authenticated, open photo modal directly
      setShowPhotoModal(true);
    } else {
      // If not authenticated, open auth modal first
      setShowAuthModal(true);
    }
  };

  // Authentication modal handlers
  const handleAuthConfirm = () => {
    setShowAuthModal(false);
    // After successful authentication, proceed with form submission
    handleSubmit();
  };

  const handleAuthClose = () => {
    setShowAuthModal(false);
  };



  // Photo registration modal handlers
  const handlePhotoConfirm = () => {
    setShowPhotoModal(false);
  };

  const handleProfilePhotoUpload = (photoUrl) => {
    // Update profile photo immediately when photo is uploaded
    setProfilePhotoUrl(photoUrl);
  };

  const handlePhotoClose = () => {
    setShowPhotoModal(false);
  };

  return (
    <div className="memorial-album-writing-pc page-memorial-album-writing-pc  announcement-list-page cyber-info-page-pc">

      <FamilyPlazaTopSection />

      <main className="main-content">

        <FamilyPlazaSubHeading heading="사이버추모관" />
      
 

      {/* Main Content */}
      <div className="memorial-album-writing-main-content">
        
                    {/* Profile Section - HORIZONTAL LAYOUT */}
            <DeceasedPersonProfile 
              handlePhotoIconClick={handlePhotoIconClick}
            />
          

        {/* Action Tabs Navigation */}
        <div className="memorial-album-writing-action-tabs">
          <div className="memorial-album-writing-action-tabs-container">
            <ul>
                                <li><Link to="/donate">헌화하기</Link></li>
              <li><Link to="/memorial-post-board-list">추모글</Link></li>
              <li><Link to="/memorial-album-board-list" className="active">추모앨범</Link></li>
            </ul>
          </div>
        </div>
        
        {/* Content Area */}
        <div className="memorial-album-writing-content-area">
          {/* Album Writing Form */}
          <div className="memorial-album-writing-form">
            <div className="memorial-album-writing-form-row">
              <label className="memorial-album-writing-form-label">제목</label>
              <input 
                type="text" 
                className="memorial-album-writing-title-input"
                placeholder=""
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            
            <div className="memorial-album-writing-form-row">
              <label className="memorial-album-writing-form-label">사진첨부</label>
              <div className="memorial-album-writing-photo-section">
                <div className="memorial-album-writing-photo-input-container">
                  <input 
                    type="text" 
                    className="memorial-album-writing-photo-input"
                    placeholder="Search"
                    value={photoDescription}
                    onChange={(e) => setPhotoDescription(e.target.value)}
                  />
                  <div className="memorial-album-writing-photo-upload-btn" onClick={handlePhotoUpload}>
                    <div className="memorial-album-writing-folder-search-icon">
                      <img src="/images/icon.png" alt="Upload Icon" />
                      <div className="memorial-album-writing-search-overlay">
                        <svg width="4" height="4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" stroke="#666" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" opacity="0.5"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Image Preview */}
                <div className="memorial-album-writing-image-preview">
                  <img src={previewImage} alt="Preview" />
                  <button className="memorial-album-writing-remove-image" onClick={handleRemoveImage}>
                    <FiX />
                  </button>
                </div>
                
                {/* Upload Guidelines */}
                <div className="memorial-album-writing-upload-guidelines">
                  <ul>
                    <li>최적 사진 사이즈는 100x100px입니다.</li>
                    <li>한번에 업로드 가능한 파일 크기는 10MB 이하입니다.</li>
                  </ul>
                </div>
              </div>
            </div>
            
            {/* Action Buttons */}
            <div className="memorial-album-writing-form-actions">
              <button className="memorial-album-writing-cancel-btn" onClick={handleCancel}>취소</button>
              <button className="memorial-album-writing-register-btn" onClick={handleSubmit}>등록</button>
            </div>
          </div>
        </div>
        
      </div>

      

      {/* Authentication Modal */}
      <ContractorAuthenticationModal
        isOpen={showAuthModal}
        onConfirm={handleAuthConfirm}
        onClose={handleAuthClose}
      />

      {/* Portrait Photo Registration Modal */}
      <PortraitPhotoRegistrationModal
        isOpen={showPhotoModal}
        onConfirm={handlePhotoConfirm}
        onClose={handlePhotoClose}
        onPhotoUpload={handleProfilePhotoUpload}
      />
      </main>
    </div>
  );
};

export default MemorialAlbumWritingPC; 